import { render } from "./DelayPropsCmp.vue?vue&type=template&id=388b1d62"
import script from "./DelayPropsCmp.vue?vue&type=script&lang=js"
export * from "./DelayPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__